itsoftApp.createModule("accordion", function () {
    const module = this;

    const AccordionItem = function (accordionItemElement, ACCORDION) {
        this.ACCORDION = ACCORDION;
        this.state = {
            opened: accordionItemElement.classList.contains("js-accordion-item--active")
        };
        accordionItemElement.accordionItem = this;
        this.accordionItemElement = accordionItemElement;
        this.accordionHeadElement = accordionItemElement.querySelector(".js-accordion-head");
        this.accordionContentElement = accordionItemElement.querySelector(".js-accordion-content");
        this.accordionText = accordionItemElement.querySelector(".js-accordion-text");
        
        this.preventNone = this.accordionHeadElement.hasAttribute("data-prevent-none");
        this.once = this.accordionHeadElement.hasAttribute("data-once");
        this.init();
        accordionItemElement.instance = this;
    };

    AccordionItem.prototype.init = function () {
        const ACCORDION_ITEM = this;
        this.openListener = ACCORDION_ITEM.onOpenTransitionEnd.bind(ACCORDION_ITEM);
        this.closeListener = ACCORDION_ITEM.onCloseTransitionEnd.bind(ACCORDION_ITEM);
        this.accordionHeadElement.addEventListener("click", ACCORDION_ITEM.onAccordionClick.bind(ACCORDION_ITEM));
    };

    AccordionItem.prototype.onAccordionClick = function (evt) {
        if (!this.preventNone) {
            /* если специально не указан атрибут data-prevent-none, отменяем действие по умолчанию, например, переход по ссылке */
            evt.preventDefault();
        }

        /* если элемент аккордеона уже активен, скрываем его... */
        if (this.state.opened && this.ACCORDION.currentClosedItem == false) {
            if (this.ACCORDION.leastOne) {
                return;
            }

            this.ACCORDION.currentClosedItem = this.ACCORDION.activeItem;
            this.ACCORDION.activeItems.splice(this.ACCORDION.activeItems.indexOf(this.ACCORDION.activeItem), 1);
            this.ACCORDION.activeItem = "";
            this.closeAccordion();

            // if (this.ACCORDION.accordionType !== "any" && this.ACCORDION.activeItems.length === 0) {
            if (this.ACCORDION.activeItems.length === 0) {
                this.ACCORDION.state.opened = false;
                this.ACCORDION.accordion.classList.remove("js-accordion--active");
            }

        /* ...иначе показываем */
        } else {
            /* если одновременно может быть раскрыт только один элемент, то есть нет атрибута data-type со значением any... */
            if (this.ACCORDION.accordionType !== "any") {
                /*...находим ранее активный элемент и скрываем его */

                if (this.ACCORDION.activeItem && this.ACCORDION.currentClosedItem == false) {
                    this.ACCORDION.currentClosedItem = this.ACCORDION.activeItem;
                    this.ACCORDION.activeItems.splice(this.ACCORDION.activeItems.indexOf(this.ACCORDION.activeItem), 1);
                    this.ACCORDION.activeItem = "";
                    this.ACCORDION.currentClosedItem.closeAccordion(); // Закрываем не текущий, а ранее активный элемент аккордеона
                }
            }

            /* показываем элемент, по которому был осуществлён клик */
            if (this.ACCORDION.currentOpenedItem == false) {
                this.ACCORDION.currentOpenedItem = this;
                this.openAccordion();

                if (!this.ACCORDION.state) {
                    this.ACCORDION.state.opened = true;
                    this.ACCORDION.accordion.classList.add("js-accordion--active");
                }

                if (this.ACCORDION.activeItems.length === this.ACCORDION.allItems.length && !this.ACCORDION.state.openedAll) {
                    this.ACCORDION.state.openedAll = true;
                } else if (this.ACCORDION.activeItems.length < this.ACCORDION.allItems.length && this.ACCORDION.state.openedAll) {
                    this.ACCORDION.state.openedAll = false;
                }
            }

            this.ACCORDION.accordion.classList.add("js-accordion--active");
        }

        /* если есть атрибут data-once, то клик по элементу аккордеона отлавливается только один раз, то есть его нельзя закрыть */
        if (this.once) {
            this.accordionHeadElement.removeEventListener("click", this.onAccordionClick.bind(this));
        }
    };

    AccordionItem.prototype.closeAccordion = function (now = false) {
        const ACCORDION_ITEM = this;
        let closedText = this.accordionItemElement.getAttribute("data-closed-text"); // todo: Проверить работу
        let height = this.accordionContentElement.clientHeight + "px";
        this.accordionItemElement.classList.add("js-accordion-item--close-ready");
        this.accordionContentElement.style.height = height;

        if (closedText) {
            this.accordionText.textContent = closedText; // TODO: Проверить работу
        }

        if (getComputedStyle(this.accordionContentElement).transition && !now) { // TODO: доработать, так как отрицательно влияет на рендеринг
            this.accordionContentElement.addEventListener("transitionend", this.closeListener);

            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    ACCORDION_ITEM.accordionContentElement.style.height = "0px";
                });
            });
        } else {
            ACCORDION_ITEM.accordionContentElement.style.height = "0px";
            this.onCloseTransitionEnd();
        }
    }

    AccordionItem.prototype.onCloseTransitionEnd = function () {
        // стили находятся в файле /assets/styles/page.styl
        this.accordionItemElement.classList.remove("js-accordion-item--active");
        this.accordionItemElement.classList.remove("js-accordion-item--close-ready");
        this.accordionContentElement.removeEventListener("transitionend", this.closeListener);

        // if (this.ACCORDION.accordionType !== "any") {
            this.ACCORDION.currentClosedItem = "";
        // }

        if (this.ACCORDION.heightUpdateFlag) {
            window.gsap && itsoftApp.libraries.scrollTrigger.loaded && ScrollTrigger.refresh();
        }

        this.state.opened = false;
    };

    AccordionItem.prototype.openAccordion = function () {
        const ACCORDION = this;
        let openedText = this.accordionItemElement.getAttribute("data-opened-text"); //todo: проверить

        /* если есть атрибут со значением, заменяем название элемента аакордеона во время открытия */
        if (openedText) {
            this.accordionText.textContent = openedText; // todo: проверить
        }

        this.accordionItemElement.classList.add("js-accordion-item--open-ready");
        this.accordionContentElement.style.height = "auto";
        let height = this.accordionContentElement.clientHeight + "px";
        this.accordionContentElement.style.height = "0px";

        if (getComputedStyle(this.accordionContentElement).transition) { // TODO: доработать, так как отрицательно влияет на рендеринг
            this.accordionContentElement.addEventListener("transitionend", this.openListener);

            /* чтобы была анимация открытия */
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    ACCORDION.accordionContentElement.style.height = height;
                });
            });
        } else {
            ACCORDION.accordionContentElement.style.height = height;
            this.onOpenTransitionEnd();
        }
    };

    AccordionItem.prototype.onOpenTransitionEnd = function () {
        // стили находятся в файле /assets/styles/page.styl
        /* если одноврменно может быть показан только один элемент аккордеона, то добавляем другую анимацию,
        //     чтобы раскрытый аккордеон не ушел за пределы экрана из-за прокрутки страницы */
        this.accordionItemElement.classList.remove("js-accordion-item--open-ready");
        this.accordionItemElement.classList.add("js-accordion-item--active");
        this.accordionContentElement.removeEventListener("transitionend", this.openListener);

        // if (this.ACCORDION.accordionType !== "any") {
        this.ACCORDION.activeItem = this;
        this.ACCORDION.activeItems.push(this);
        this.ACCORDION.currentOpenedItem = "";
        // }

        if (this.ACCORDION.heightUpdateFlag) {
            window.gsap && itsoftApp.libraries.scrollTrigger.loaded && ScrollTrigger.refresh();
        }

        this.state.opened = true;
    };

    const Accordion = function (accordion) {
        this.state = {
            opened: false,
            openedAll: false
        },
        this.accordion = accordion;
        this.accordionType = accordion.getAttribute("data-type");
        this.leastOne = accordion.hasAttribute("data-least-one");
        this.accordionItemElements = accordion.querySelectorAll(".js-accordion-item");
        this.accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");
        this.allItems = [];
        this.activeItems = [];
        this.activeItem = "";
        this.activeAccordionContent = "";
        this.currentItem = "";
        this.currentOpenedItem = "";
        this.currentClosedItem = "";
        this.currentOpenedContent = "";
        this.currentClosedContent = "";
        this.heightUpdateFlag = accordion.hasAttribute("data-height-update");

        this.init();
    };

    Accordion.prototype.init = function () {
        /* Добавляет каждому элементу аккордеона обработчик события клика */
        const ACCORDION = this;

        Array.from(ACCORDION.accordionItemElements).forEach(function (el) {
            const accordionItem = new AccordionItem(el, ACCORDION);
            ACCORDION.allItems.push(accordionItem);

            if (accordionItem.state.opened) {
                ACCORDION.activeItems.push(accordionItem);

                // if (ACCORDION.accordionType !== "any") { // todo: Обязательно протестировать этот момент
                ACCORDION.activeItem = accordionItem;
                // }
            }
        });

        const debouncedUpdate = itsoftApp.utils.debouncer(function () {
            if (ACCORDION.accordion.classList.contains("js-accordion--active")) {
                Array.prototype.forEach.call(ACCORDION.activeItems, function (el) {
                    let content = el.accordionContentElement;
                    content.style.height = "auto";
                    let height = content.clientHeight + "px";
                    content.style.height = height;
                });
            }
        }, 500);

        itsoftApp.modules.windowResize.addEvent(function () {
            debouncedUpdate();
        });
    };

    module.callback = Accordion;
});